import { createSlice } from '@reduxjs/toolkit';

export const translateSlice = createSlice({
    name: 'alert',
    initialState: {
        language: 'es-MX',
    },
    reducers: {
        changeLanguage: (state, action) => {
            state.language = action.payload
            return state
        }
    }
})

// Action creators are generated for each case reducer function
export const { changeLanguage } = translateSlice.actions

export default translateSlice.reducer